import { render, staticRenderFns } from "./payfailure.vue?vue&type=template&id=079e2c3c&scoped=true&"
import script from "./payfailure.vue?vue&type=script&lang=js&"
export * from "./payfailure.vue?vue&type=script&lang=js&"
import style0 from "./payfailure.vue?vue&type=style&index=0&id=079e2c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e2c3c",
  null
  
)

export default component.exports